var path = '/var/www/mmscny-website/src/app/components/page-not-found/page-not-found.html';
var html = "<section class=page-not-found-section> <div class=container> <div class=error-message> <div class=error-code> <span>4</span> <span>0</span> <span>4</span> </div> <div class=error-help-text> <span class=help-text_dark>Opps, Sorry we can’t find that page!</span> <span class=help-text_light>Either something went wrong or the page doesn’t exist anymore.</span> <div class=green-button ng-click=$ctrl.goHome()> <span><div class=\"btn-green text-uppercase\">go home</div></span> </div> </div> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page-not-found/page-not-found.html
// module id = 689
// module chunks = 0